import { PreviousRouteService } from 'src/app/core/services/previous-route.service';
import { Component, OnInit } from '@angular/core';
import { PreviousRoute } from 'src/app/core/models/PreviousRoute';
import { QrCartStore } from 'src/app/core/qr-cart/qr-cart.store';
import { SessionStorageService } from '../../storage/session-storage.service';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { Subscription } from 'rxjs';
import { StoreService } from 'src/app/store/store/store.service';

@Component({
  selector: 'app-store-not-found-error',
  templateUrl: './store-not-found-error.component.html',
  styleUrls: ['./store-not-found-error.component.scss']
})
export class StoreNotFoundErrorComponent implements OnInit {
  route: PreviousRoute;
  errorCode: string;
  errror$: Subscription;

  constructor(
    private previousRouteService: PreviousRouteService,
    private qrCartStore: QrCartStore,
    private sessionStorageService: SessionStorageService,
    private navigationService: NavigationService,
    private storeService: StoreService,
  ) { }

  ngOnInit(): void {
    this.errror$ = this.storeService.getErrorData().subscribe((dt: any) => {
      if (dt) {
        this.errorCode = dt?.errorCode ?? null;
      }
    })

    if (this.sessionStorageService.getItem("qrTokenResponse")) {
      this.sessionStorageService.removeItem("qrTokenResponse");
      this.qrCartStore.update({ qrTokenResponse: null });
    }

    this.route = this.previousRouteService.getPreviousRoute();
  }

  goBackToPreviousPage() {
    if (this.route?.activityId) {
      let data = { 'activityId': this.route.activityId };

      try {
        this.sessionStorageService.setItem("orderDetail", JSON.stringify(data));
      } catch (e) {
        console.log("Failed to set session storage", e)
      }
    }

    this.previousRouteService.removePreviousRoute();

    if (this.route?.routeName) {
      this.navigationService.navigateByUrl(this.route.routeName);
    }
    else {
      this.navigationService.navigate(['home']);
    }
  }

  ngOnDestroy() {
    this.errror$?.unsubscribe();
  }

}
